import { render } from "./ButtonStyle.vue?vue&type=template&id=ac530214"
import script from "./ButtonStyle.vue?vue&type=script&lang=ts"
export * from "./ButtonStyle.vue?vue&type=script&lang=ts"
script.render = render

export default script